<script setup>
import { reactive, onMounted } from 'vue'
import { getById } from '@/api/modules/role'

const $props = defineProps({
  id: {
    type: String,
    required: true
  },
  type: {
    type: String,
    default: 'info'
  },
  closable: {
    type: Boolean,
    default: false
  }
})
const $emits = defineEmits(['close'])

let roleInfo = reactive({
  id: $props.id,
  name: undefined
})
onMounted(() => {
  if (!$props.id) {
    throw new Error('username is required')
  }
  getById($props.id).then((res) => {
    if (res.success) {
      roleInfo.id = res.data.id
      roleInfo.name = res.data.name
    }
  })
})
const onClose = () => {
  $emits('close', $props.id)
}
</script>
<template>
  <el-tag round :closable="$props.closable" :type="type" effect="light" @close="onClose">
    <div class="flex-center" style="gap: 4px; grid-gap: 4px">
      <span>{{ roleInfo.name || id }}</span>
    </div>
  </el-tag>
</template>

<style scoped lang="scss">
:deep(.el-tag__content:only-child) {
  margin-right: 4px;
}
</style>
